import { Accordion, Button, Stack, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import Card from 'components/Card';
import DataTables from 'components/DataTables';
import ModalAddActivity from 'modules/pages/lcms/courses/ModalAddActivity';
import ModalDelete from 'modules/pages/lcms/courses/ModalDelete';
import React, { useState } from 'react';
import styles from './styles.module.css';
import MaterialLink from 'modules/pages/lcms/courses/MaterialLink';

interface Activity {
  activityName: string;
  activityId: string;
  activityType: string;
}

interface ActivityFormProps {
  control?: any;
  errors?: any;
  setValue: any;
  activities: Activity[];
}

const ActivityForm: React.FC<ActivityFormProps> = ({ setValue, activities }) => {
  const [opened, { open, close }] = useDisclosure(false);
  const [openedModalDelete, { open: openModalDelete, close: closeModalDelete }] =
    useDisclosure(false);
  const [selectedActivity, setSelectedActivity] = useState<Activity | null>(null);

  const columns = [
    {
      heading: 'Activity ID',
      props: 'activityId',
      active: true,
      sortable: true
    },
    {
      heading: 'Activity Name',
      props: 'activityName',
      active: true,
      sortable: true
    },
    {
      heading: 'Activity Type',
      props: 'activityType',
      active: true,
      sortable: true
    },
    {
      heading: 'Course Name',
      props: 'courseName',
      active: true,
      sortable: true
    },
    {
      heading: 'Beelajar LMS Link',
      props: ({ activityUrl }: { activityUrl: string }) => (
        <MaterialLink linkMaterial={activityUrl} title={'Link'} isBeelajarLoginLink={true} />
      ),
      active: true,
      sortable: false
    },
    {
      heading: 'Action',
      props: 'action',
      active: true,
      sortable: true
    }
  ];

  const handleDelete = (row: Activity) => {
    setSelectedActivity(row);
    openModalDelete();
  };

  const handleRemovedActivity = () => {
    if (selectedActivity) {
      const _activities = activities.filter(
        (item: any) => item.activityId !== selectedActivity.activityId
      );
      setValue('activities', _activities);
      handleCloseModal();
      return;
    }
  };

  const handleCloseModal = () => {
    closeModalDelete();
    setSelectedActivity(null);
  };

  return (
    <>
      <Accordion.Item className={styles.accordionItem} value='activity'>
        <Accordion.Control className={styles.accordionControl}>Activity</Accordion.Control>
        <Accordion.Panel className={styles.accordionPanel}>
          <Stack gap='lg' py={16}>
            <Button variant='outline' fullWidth onClick={() => open()}>
              Add Activity
            </Button>

            <Card>
              <Stack>
                <Text fw={700}>Activity List</Text>
                <DataTables
                  data={activities}
                  columns={columns}
                  withPagination={false}
                  handleDelete={handleDelete}
                  urlEmptyImage={'/images/illustration-empty-data-1.svg'}
                  emptyMessageTitle={'No activity added'}
                  emptyMessageDescription={'Try added the activity on “Add Activity” button'}
                />
              </Stack>
            </Card>
          </Stack>
        </Accordion.Panel>
      </Accordion.Item>
      <ModalAddActivity
        opened={opened}
        onClose={() => close()}
        onSubmit={(data) => {
          close();
          setValue('activities', [...activities, ...data]);
        }}
      />

      <ModalDelete
        opened={openedModalDelete}
        onClose={handleCloseModal}
        activityName={selectedActivity?.activityName}
        onConfirm={handleRemovedActivity}
      />
    </>
  );
};

export default ActivityForm;
